import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {TravelRuleType, TravelTimeRuleModel} from "../../models/travel-time-rule.model";

export class TravelTimeRulePanel implements IController {

  rule: TravelTimeRuleModel;
  serviceAreas: any[];
  onUpdate: Function;
  onCreate: Function;
  onCancel: Function;
  globalRuleExists: boolean;

  public ruleCopy: TravelTimeRuleModel;  // For edit mode
  public travelTimeFactorPercent: number;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.ruleCopy = undefined;

    if (this.rule) {
      this.ruleCopy = angular.copy(this.rule);
      this.ruleCopy.type = this.rule.type || TravelRuleType.AREA;
    }

  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.rule) {
      this.ruleCopy = this.rule ? angular.copy(this.rule) : undefined;
      this.travelTimeFactorPercent = this.ruleCopy?.travelTimeFactor ? _.round(this.ruleCopy.travelTimeFactor * 100, 2) : undefined;
    }
  }

  onTypeChange(type: TravelRuleType) {
    this.ruleCopy.type = type;
    if (type === TravelRuleType.GLOBAL) {
      this.ruleCopy.polygons = null;
      this.ruleCopy.name = 'Global';
    } else {
      this.ruleCopy.polygons = this.ruleCopy.polygons || [];
      this.ruleCopy.name = this.ruleCopy.name === 'Global' ? undefined : this.ruleCopy.name;
    }
  }

  onTravelTimeFactorChange(travelTimeFactorPercent) {
    this.ruleCopy.travelTimeFactor = _.round(travelTimeFactorPercent / 100, 2);
  }

  onAddPolygonToRule(feature) {
    const polygon = {
      basedOnArea: feature?.properties?.areaName,
      id: feature?.properties.areaId,
      polygonVertices: _.map(feature?.geometry?.coordinates[0], (coords) => {
        return {
          lng: coords[0],
          lat: coords[1],
          // longitude: coords[0],
          // latitude: coords[1]
        }
      })
    }
    this.ruleCopy.polygons = this.ruleCopy.polygons.concat([polygon]);
  }

  onUpdatePolygonOnRule(feature, index) {
    const polygon = {
      basedOnArea: feature?.properties?.areaName,
      id: feature?.properties.areaId,
      polygonVertices: _.map(feature?.geometry?.coordinates[0], (coords) => {
        return {
          lng: coords[0],
          lat: coords[1],
          // longitude: coords[0],
          // latitude: coords[1]
        }
      })
    }
    const polygonsCopy = angular.copy(this.ruleCopy.polygons);
    polygonsCopy.splice(index, 1, polygon);
    this.ruleCopy.polygons = polygonsCopy;
  }

  onRemovePolygonFromRule(index) {
    this.ruleCopy.polygons = _.filter(this.ruleCopy.polygons, (p, i) => {
      return i !== index;
    });
  }

  onSubmitCreate(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        this.onCreate({rule: this.ruleCopy});
      }

    }
  }

  onSubmitUpdate(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        this.onUpdate({rule: this.ruleCopy});
      }

    }
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('travelTimeRulePanel', {
    bindings: {
      rule: '<',
      serviceAreas: '<?',
      globalRuleExists: '<?',
      onUpdate: '&',
      onCreate: '&',
      onCancel: '&'
    },
    template: require('./travel-time-rule-panel.html').default,
    controller: TravelTimeRulePanel
  });
